module.exports = __webpack_public_path__ + "static/media/Formato_Arco_2019.082b3333.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/Formato_Arco_2019.pdf
// module id = 775
// module chunks = 0